<template v-if="true" >
  <div style="height:100%;padding:10px;text-align:center">
    <!-- <Steps :current="current" :offset-top="20">
      <Step title="选择信息"></Step>
      <Step title="操作结果"></Step>
    </Steps> -->

    <div :offset-top="height * 0.15" v-show="showStep1">
      <sgbingstep1 ref="sgbingstep1"></sgbingstep1>
    </div>
    <div :offset-top="height * 0.15" v-if="showStep2">
      <sgbingstep2 ref="sgbingstep2"></sgbingstep2>
    </div>

    <div style="position: fixed; bottom: 10px;right: 10px">
      <!-- <Button type="primary" @click="callBackReturn" v-show="showStep4">返回</Button> -->
      <Button type="primary" @click="bindSGInfo" v-show="!showStep4">提交并绑定</Button>
    </div>
  </div>
</template>
<script>
import sgbingstep1 from "../expand/SGBindStep1.vue";
import sgbingstep2 from "../expand/opResult.vue";
export default {
  components: {
    sgbingstep1,
    sgbingstep2
  },
  mounted() {},
  methods: {
    callBack(result) {
      this.showStep2 = true;
      this.showStep1 = false;
      if (result) {
        this.msg = "数据绑定成功！";
      } else {
        this.msg = "数据绑定失败，请重试！";
      }

      this.current = 1;
    //   this.$refs.sgbingstep2.changeStatus("success");
    },
    bindSGInfo() {
      this.$refs.sgbingstep1.bindSGInfo();
    },
    callBackReturn() {
      this.showStep2 = false;
      this.showStep1 = true;
      this.current = 0;
    },
    getMeterId(param) {
      this.meterLabel = param;
    },
    enabledButton(param) {
      if (param == -1) {
        this.disabledTooltip = false;
        this.disabledButtonNext = true;
      } else {
        this.disabledTooltip = true;
        this.disabledButtonNext = false;
      }
    }
  },

  data() {
    return {
      height: document.body.clientHeight,
      current: 0,
      disabledButtonNext: false,
      showStep1: true,
      showStep2: false,
      showStep3: false,
      showStep4: false,
      msg: "",
      result: "",
      viewMeterDetailed: {},
      formItem: {
        selectCondition: "",
        selectMeterType: "",
        inputIdCard: "",
        inputMeterId: ""
      }
    };
  }
};
</script>